import gql from 'graphql-tag';

import { vendorPartial } from './VendorFragment';
import { VendorCampaignBase } from './VendorCampaignFragment';

const VendorLayerDetailFragment = gql`
  fragment VendorLayerDetailFragment on VendorLayer {
    __typename
    id
    layerID
    vendorID
    networkID
    brokerID
    destinations
    description
    leadChannelDescription
    tags
    verticalType
    kindOfLead
    dupCheckLevelID
    addonPrice
    myAgentDestinations
    vendor {
      ${vendorPartial}
    }
    minimumRefresh
    autoProcessThreshold
    autoProcess
    vendorSourceCampaign
    vendorSourceCampaignMap
    vendorPrice
    maxDemandUnsoldAccepted
    splitCount
    enhanceProfile
    rejectDisconnected
    rejectDNC
    fixedBidPrice
    apiType
    maxSpendPerHour
    maxSpend
    pingPostEnabled
    pingPostType
    rejectDuplicates
    refundEligible
    refundMaxAge
    refundMaxAgeIncrement
    refundMaxAgeDateType
    pendingLeads
    errorLeads
    mpVendorCampaignName
    acceptsTermsAndConditions
    isCampaignDestination
    skipActiveDemandSubmit
    overideDuplicateChecks
    allowMLOverride
    allowMLearning
    mlVersion{
      label
      value
    }
    smartPriceAcceptence
    splitStopActiveDemand
    splitStopCountMinActiveDemand
    splitActiveDemandFallBack{
      label
      value
    }
    dupPriceThreashold
    dupPriceThreasholdLookBack
    adIncomeMax
    adHouseHoldMax
    applyOverrideFilter
    agentProfileAssigmentAllowed
    allowMLOnSubmit
    allowAPOnPing
    overrideBlockedAttributeFields{
      label
      value
    }
    overrideBlockedValues{
      label
      value
    }
    crossNetworkLayers{
      label
      value
    }
    allowSlices
    allowSplits
    deactivateActiveDemand
    heyflowBotDetection
    nonusaBotDetection
    vendorPriceInPennies
    globalWildCardFilter
    rejectTresstle
    tresstleScoreMin
    verifyDestination
    crossNetworkSplit
    networkSplitKey{
      label
      value
    }
    minNetworkSplit
    maxNetworkSplit
    isUpdateEligible
    delaySecondsForUpdate
    mlTargetConversionRate
    mlProbablityIncreasePercentage
    mlProbablityIncreasePerLead
    mlBeforeThreashold
    allowAdvanceFitering
    doNotAcceptQualityRejects
    allowMLPriceOverride
    mlTargetMinPrice
    mlTargetMaxPrice
    minAcceptenceBid
    mlAggressionPriceLevel
    mlAggressionConversionLevel
    mlNetworkOptimized
    mlCPATarget
    useEventsMLModel
    skipGTBDuplicate
    cbNewAdmin
    liveTransferAnswerTime
    liveTransferBatchCycleCount
    liveTransferBatchSize
    liveTransferDropCall
    liveTransferEmail
    liveTransferIntroGreeting,
    liveTransferNotificationsOnly
    liveTransferOverflowRedirectCall
    liveTransferPhoneNumber
    liveTransferRejectNoDataCalls
    liveTransferScript
    liveTransferTierID
    liveTransferVoiceMailUrl
    liveTransferVoip
    liveTransferWaitUrl
    liveTransfersEnabled
    liveTransferEarlyHangUpLayerID
    postAttributes
    pingAttributes
    attributeRanges{
      age {
        nextSegment
        lowestBound
        highestBound
      }
      income {
        nextSegment
        lowestBound
        highestBound
      }
      household {
        nextSegment
        lowestBound
        highestBound
      }
    }
    filters {
        __typename
        ... on VendorLayerFilterBase {
          type
        }
        ... on VendorLayerAddOnFilter{
          attributes:attribute
          resultAttribute
          include
          level
          type
          settings{
            claimCert
            priceOverride
            storeAnalytics
            ruleID
          }
        }
        ... on VendorLayerVerifyFilter{
          attributes:attribute
          attributeType
          type
          include
        }
        ... on VendorLayerSystemFilter{
          type
          functionName
          include
          rejectMessage
          skipMissing
        }
        ... on VendorLayerTimeFilter{
          type
          attribute
          min
          max
          include
          rejectType
          bidType
          bid
          skipMissing
        }
        ... on VendorLayerStaticFilter{
          include
          level
          values
          attribute
          type
          skipMissing
        }
        ... on VendorLayerMultiFilter{
          attribute
          resultAttribute
          ruleID
          valuesInt
          include
          type
          skipMissing
        }
        ... on VendorLayerRangeFilter{
          attribute
          include
          min
          max
          type
          skipMissing
          skipMissingOnPing
        }
        ... on VendorLayerDynamicFilter {
          level
          type
          attribute
          resultAttribute
          minimumRefresh
          include
          skipMissing
          allowOnPing
          settings{
            isCopy
          }
        }
    }
    apBidEnhancmentEnabled
    apSettings{
        apBidEnhancmentDynamic
        apPercentageEnabled
        apWPMMin
        apWPMMax
        apKPMMin
        apKPMMax
        apBidPrice
        apBidPercentage
    }
  }
`;

export default VendorLayerDetailFragment;
